import { FormControlLabel } from '@mui/material';
import {
  ConnectDialog,
  ConnectDialogButtons,
  ConnectDialogTitle,
} from 'modules/auth/components/ConnectDialog';
import { useWalletConnectModal } from 'modules/auth/hooks/useConnectionModal';
import { Checkbox } from 'modules/common/components/Checkbox';
import { TERMS_OF_SERVICE_LINK } from 'modules/common/const';
import { useTranslation } from 'modules/i18n';
import { useState } from 'react';
import { ConnectBinanceWeb3 } from './components/ConnectBinanceWeb3';
import { ConnectBitget } from './components/ConnectBitget';
import { ConnectMetamask } from './components/ConnectMetamask';
import { ConnectOKX } from './components/ConnectOKX';
import { ConnectTomo } from './components/ConnectTomo';
import { ConnectWalletConnect } from './components/ConnectWalletConnect';
import { translation } from './translation';
import { useConnectionStyles } from './useConnectionStyles';
import { ConnectCoinbase } from './components/ConnectCoinbase';
import { ConnectDetectedWallets } from './components/ConnectDetectedWallets';

export function ConnectionModal(): JSX.Element {
  const { isOpened, onClose } = useWalletConnectModal();
  const { keys, t } = useTranslation(translation);
  const { classes } = useConnectionStyles();

  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const isConnectDisabled = !checked;

  return (
    <ConnectDialog open={isOpened} onClose={onClose}>
      <ConnectDialogTitle
        title={t(keys.title)}
        description={t(keys.description)}
      />

      <FormControlLabel
        classes={{ root: classes.checkbox, label: classes.text }}
        control={<Checkbox checked={checked} onChange={handleCheckboxChange} />}
        label={t(keys.tosText, { link: TERMS_OF_SERVICE_LINK }, true)}
      />

      <ConnectDialogButtons>
        <ConnectMetamask isDisabled={isConnectDisabled} />

        <ConnectWalletConnect isDisabled={isConnectDisabled} />

        <ConnectOKX isDisabled={isConnectDisabled} />

        <ConnectBinanceWeb3 isDisabled={isConnectDisabled} />

        <ConnectCoinbase isDisabled={isConnectDisabled} />

        <ConnectTomo isDisabled={isConnectDisabled} />

        <ConnectBitget isDisabled={isConnectDisabled} />

        <ConnectDetectedWallets isDisabled={isConnectDisabled} />
      </ConnectDialogButtons>
    </ConnectDialog>
  );
}
